var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99945 14C7.05592 14 7.93968 13.2469 8.14262 12.25H3.85628C4.05932 13.2469 4.94308 14 5.99945 14Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4191 8.45595C10.404 8.45595 10.39 8.4583 10.3748 8.4583C7.80171 8.4583 5.7082 6.36479 5.7082 3.7917C5.7082 2.78073 6.03483 1.84688 6.5832 1.08147V0.583298C6.5832 0.260727 6.32184 0 5.9998 0C5.67787 0 5.4165 0.260727 5.4165 0.583298V1.21338C3.4407 1.49803 1.9165 3.1973 1.9165 5.25V6.87631C1.9165 8.03073 1.41075 9.12042 0.523468 9.87056C0.2966 10.0648 0.166504 10.3471 0.166504 10.6458C0.166504 11.2088 0.624405 11.6667 1.1873 11.6667H10.8123C11.3753 11.6667 11.8332 11.2088 11.8332 10.6458C11.8332 10.3471 11.7031 10.0648 11.4704 9.86596C11.0106 9.47685 10.656 8.99267 10.4191 8.45595Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconBlue);
export default __webpack_public_path__ + "static/media/NotificationIconBlue.4095e54cb82316fc10ab322433718758.svg";
export { ForwardRef as ReactComponent };